import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControllerButtonTriangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconControllerButtonTriangle"><Path d="M15.0254 14.125H8.97559L12 9.18555L15.0254 14.125Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM6.29785 15.625H17.7031L12 6.31445L6.29785 15.625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconControllerButtonTriangle;
